var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "subTab": "",
      "sh": "About us",
      "index": "03",
      "total": "04",
      "tabActive": "Organization",
      "bg": "/images/sub/visual/sv1.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first section--last"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v("Organization")])]), _c('v-img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "width": "100%",
      "src": "/images/sub/aboutus/organization-img.png"
    }
  }), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "width": "100%",
      "src": "/images/sub/aboutus/organization-m-img.png"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }